import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class MoneyOwner {
  @JsonProperty()
  id: number = -1;
  @JsonProperty()
  code: string | undefined;
  @JsonProperty()
  description: string | undefined;

  @JsonProperty()
  owner: string | undefined;
  @JsonProperty()
  ownerId:number;

  @JsonProperty()
  address: string | undefined;
  @JsonProperty()
  zipCode: string | undefined;
  @JsonProperty()
  town: string | undefined;
  @JsonProperty()
  country: string | undefined;

  // BILLING MODULE
  @JsonProperty()
  currency: string | undefined;
  @JsonProperty()
  invoiceMail: string | undefined;
  @JsonProperty()
  outstandingDebt:number = 0;
  @JsonProperty()
  bankAccountId:number = 0;
  @JsonProperty()
  billingDueNbDays:number = 0;
  @JsonProperty()
  vat:boolean = false;

  @JsonProperty()
  modificationDate: DateTime = DateTime.now();
  @JsonProperty()
  creationDate: DateTime = DateTime.now();
  @JsonProperty()
  vatNumber: string | undefined;
  @JsonProperty()
  stateAddress: string | undefined;

  @JsonProperty()
  invoiceTemplate: string | undefined;


}
